import type { SecuritySettingsFeatureConfig } from '../type';

export const securitySettingsConfig: Partial<SecuritySettingsFeatureConfig> = {
    alternateExternalClientId: 'ebcstore',
    externalTargets: ['limits'],
};
